import React from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import { FormInputField } from '../../../../../semantic-ui/components/form-input-field';
import { FormSelect } from '../../../../../semantic-ui/components/form-select';
import { FormTextAreaField } from '../../../../../semantic-ui/components/form-textarea-field';
import { normalizeInteger } from '../../../../../utils/normalizeInteger';
import { MinuteIcon } from '../../../../../components/text-icon';
import { FormSelectField } from '../../../../../semantic-ui/components/form-select-field';

export const AddressFormView = ({
	addressFormOptions,
	isAddressFormOptionsLoading,
	onAddressSearchChange,
	onAddressChange,
	addressFormSearchValue,
	timezones,
	isTimezonesLoading,
}) => {
	return (
		<div className="address-form">
			<section className="address-form__section">
				<div className="address-form__row">
					<span className="address-form__text address-form__text_right">Наименование склада</span>
					<div className="address-form__field">
						<Field
							name="name"
							type="text"
							component={FormInputField}
							autoComplete="off"
							placeholder="Укажите наименование склада"
						/>
					</div>
				</div>
				<div className="address-form__row">
					<span className="address-form__text address-form__text_right">Адрес склада</span>
					<div className="address-form__field">
						<Field
							name="address"
							type="text"
							component={FormSelect}
							autoComplete="off"
							placeholder="Укажите адрес склада"
							icon="search"
							options={addressFormOptions}
							loading={isAddressFormOptionsLoading}
							noResultsMessage="Неизвестный адрес"
							onSearchChange={onAddressSearchChange}
							onItemChange={onAddressChange}
							searchValue={addressFormSearchValue}
						/>
					</div>
				</div>
				<div className="address-form__row">
					<span className="address-form__text address-form__text_right">Режим работы</span>
					<div className="address-form__field">
						<Field
							name="work_mode"
							type="text"
							component={FormInputField}
							autoComplete="off"
							placeholder="Укажите режим работы (ПН-ПТ, 09:00-19:00)"
						/>
					</div>
				</div>
				<div className="address-form__row">
					<span className="address-form__text address-form__text_right">Окно отгрузки</span>
					<div className="address-form__field">
						<div className="address-form__time-fields-wrapper">
							<div className="address-form__field_with-time">
								<Field
									name="pickup_time_from"
									type="time"
									component={FormInputField}
									autoComplete="off"
									placeholder="00:00"
								/>
							</div>
							<span className="address-form__time-fields-separator">-</span>
							<div className="address-form__field_with-time">
								<Field
									name="pickup_time_to"
									type="time"
									component={FormInputField}
									autoComplete="off"
									placeholder="00:00"
								/>
							</div>
						</div>
					</div>
				</div>
				<div className="address-form__row">
					<span className="address-form__text address-form__text_right">Время отгрузки со склада</span>
					<div className="address-form__field">
						<Field
							name="pickup_time"
							type="text"
							normalize={normalizeInteger}
							component={FormInputField}
							autoComplete="off"
							placeholder="Укажите время отгрузки со склада"
							icon={MinuteIcon}
						/>
					</div>
				</div>
				<div className="address-form__row">
					<span className="address-form__text address-form__text_right">Окно доставки</span>
					<div className="address-form__field">
						<div className="address-form__time-fields-wrapper">
							<div className="address-form__field_with-time">
								<Field
									name="drop_time_from"
									type="time"
									component={FormInputField}
									autoComplete="off"
									placeholder="00:00"
								/>
							</div>
							<span className="address-form__time-fields-separator">-</span>
							<div className="address-form__field_with-time">
								<Field
									name="drop_time_to"
									type="time"
									component={FormInputField}
									autoComplete="off"
									placeholder="00:00"
								/>
							</div>
						</div>
					</div>
				</div>
				<div className="address-form__row">
					<span className="address-form__text address-form__text_right">Время разгрузки у клиента</span>
					<div className="address-form__field">
						<Field
							name="drop_time"
							type="text"
							normalize={normalizeInteger}
							component={FormInputField}
							autoComplete="off"
							placeholder="Укажите время разгрузки у клиента"
							icon={MinuteIcon}
						/>
					</div>
				</div>
				<div className="address-form__row">
					<span className="address-form__text address-form__text_right">Время на отъезд</span>
					<div className="address-form__field">
						<Field
							name="departure_time"
							type="text"
							normalize={normalizeInteger}
							component={FormInputField}
							autoComplete="off"
							placeholder="Укажите время на отъезд"
							icon={MinuteIcon}
						/>
					</div>
				</div>
				<div className="address-form__row">
					<span className="address-form__text address-form__text_right">Атрибут</span>
					<div className="address-form__field">
						<Field
							name="attr"
							type="text"
							component={FormInputField}
							autoComplete="off"
							placeholder="Укажите атрибут"
						/>
					</div>
				</div>
				<div className="address-form__row">
					<span className="address-form__text address-form__text_right">Часовой пояс</span>
					<div className="address-form__field">
						<Field
							name="timezone"
							type="text"
							component={FormSelectField}
							autoComplete="off"
							options={timezones}
							search
							dropdownClassName="static"
							loading={isTimezonesLoading}
							disabled={isTimezonesLoading}
							noResultsMessage="Не найдено"
							placeholder="Выберите часовой пояс"
							isWithoutSelectOnBlur
						/>
					</div>
				</div>
				<div className="address-form__row">
					<span className="address-form__text address-form__text_right">Примечание</span>
					<div className="address-form__field">
						<Field
							name="comment"
							type="text"
							component={FormTextAreaField}
							autoComplete="off"
							placeholder="Укажите примечание"
							width="100%"
							resize="vertical"
						/>
					</div>
				</div>
			</section>
		</div>
	);
};

AddressFormView.propTypes = {
	addressFormOptions: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string.isRequired,
			value: PropTypes.string.isRequired,
			text: PropTypes.string,
			data: PropTypes.shape({
				title: PropTypes.string.isRequired,
				address: PropTypes.string.isRequired,
				deleted: PropTypes.bool,
			}),
		}),
	).isRequired,
	isAddressFormOptionsLoading: PropTypes.bool.isRequired,
	onAddressSearchChange: PropTypes.func.isRequired,
	onAddressChange: PropTypes.func.isRequired,
	addressFormSearchValue: PropTypes.string.isRequired,
	isTimezonesLoading: PropTypes.bool.isRequired,
	timezones: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string.isRequired,
			value: PropTypes.string.isRequired,
			text: PropTypes.string.isRequired,
		}),
	).isRequired,
};
